// extracted by css-extract-rspack-plugin
export default {"spaceXSmall":"8px","spaceLarge":"32px","container":"workflow__container___lnv0i","section":"workflow__section___KjR_Q"};